import { render } from "./base-pagination.vue?vue&type=template&id=2eb2cffa&scoped=true&ts=true"
import script from "./base-pagination.vue?vue&type=script&lang=ts"
export * from "./base-pagination.vue?vue&type=script&lang=ts"

import "./base-pagination.vue?vue&type=style&index=0&id=2eb2cffa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb2cffa"]])

export default __exports__